export default {
  // list
  total: 0,
  pages: 1,
  page: 1,
  limit: 10,
  sortBy: 'id',
  sortDesc: true,
  list: [],

  // search
  conditions: {
    published_at_start: '',
    published_at_end: '',
    users: ['my', 'other'],
    status: ['draft', 'public', 'finish', 'cancel'],
    type: ['sell', 'buy'],
    id: '',
    maker: '',
    name: '',
    cas_no: '',
    fema_no: '',
    pieces: '',
    nums: '',
    synonym: '',
  },

  // info
  info: {
    id: null,
    status: 'draft',
    type: 'sell',
    maker: '',
    name: '',
    cas_no: '',
    fema_no: '',
    pieces: '',
    nums: '',
    synonym: '',
    user_name: null,
    published_at: '',
    updated_at: '',
  },

  // edit
  form: {
    id: null,
    status: '',
    type: 'sell',
    maker: '',
    name: '',
    cas_no: '',
    fema_no: '',
    pieces: '',
    nums: '',
    synonym: '',
  },

  // uploads
  uploads: [],
};
